<script>

import { loans } from './stores.js';
import { calculateCurrentLoanAmount, calculateFullCostByLoan, calculateFullCost
} from './loancalc.js'

loans.subscribe(l => {
    window.localStorage.setItem('loans', JSON.stringify(l));
})

let amount
let rate
let payment

$: disabled = !(rate && amount && payment);

function removeLoan(i) {
    $loans.splice(i, 1)
    loans.set($loans)
}

function addLoan(e) {
    try {
        calculateFullCost(amount, payment, rate);
    } catch (e) {
        alert('Hmm. This loan will never be paid off. Try again.');
        return;
    }
    loans.update(l => { 
        l.push({
            amount: amount,
            rate: rate,
            payment: payment,
            created_at: (new Date).getTime()
        })
        return l
    })
    rate = null
    amount = null
    payment = null
}

</script>

<div>
    <h2 class="title is-3 mt-4">Add a Loan</h2>
    <form on:submit|preventDefault={addLoan} novalidate>
        <div class="columns mb-0">
            <div class="field column mb-0">
                <label class="label">Amount left in loan</label>
                <div class="control">
                    <input class="input" placeholder="1000" type="number" bind:value="{amount}" />
                </div>
            </div>
            <div class="field column mb-0">
                <label class="label">Interest rate</label>
                <div class="control">
                    <input class="input" placeholder="3.14" type="number" bind:value="{rate}" />
                </div>
            </div>
            <div class="field column mb-0">
                <label class="label">Monthly payment</label>
                <div class="control">
                    <input class="input" placeholder="100" type="number" bind:value="{payment}" />
                </div>
            </div>
        </div>

        <p class="help">To keep things simple, we assume an amortized loan with daily compounding interest.</p>
        <p class="help">And if you come back we'll try to keep track of how much you would have paid off. But since we don't know exactly when you're paying, its not going to be exact. Don't think too hard.</p>

        <div class="columns mt-2 is-mobile is-centered">
            <div class="column is-narrow">
                <button class="button is-success" type="submit" {disabled}>Save</button>
            </div>
        </div>
    </form>
</div>

<style></style>
